<ng-container *ngIf="canViewShipments$ | async; else notAllowed">
    <div class="dashboard-container container-fluid bg-white overflow-auto p-4" id="staticDashboard">
        <div class="pb-3 mt-3">
            <h4 *ngIf="user$ | async; let user">{{ greeting | translate }} {{ user.name }}</h4>
            <p>{{ 'portal.dashboard.snapshot-message' | translate }}</p>
            <qwyk-onboarding-banner
                *ngIf="onboardingStatus$ | async as onboardingStatus"
                [onboardingStatus]="onboardingStatus"
            ></qwyk-onboarding-banner>
        </div>

        <qwyk-onboarding-notice
            *ngIf="onboardingStatus$ | async as onboardingStatus"
            [onboardingStatus]="onboardingStatus"
        ></qwyk-onboarding-notice>

        <div class="pb-3" *ngIf="view$ | async; let view">
            <qw-ops-dashboard *ngIf="view === 'ops'"></qw-ops-dashboard>
        </div>
    </div>
</ng-container>

<ng-template #notAllowed>
    <div class="dashboard-container container-fluid bg-white overflow-auto p-4" id="staticDashboard">
        <div class="pb-3 mt-3">
            <h4 *ngIf="user$ | async; let user">{{ greeting | translate }} {{ user.name }}</h4>
            <p>{{  'portal.dashboard.default-message' | translate }}</p>
        </div>
    </div>
</ng-template>
